module.exports = __webpack_public_path__ + "img/pad_code.jpg";